
const initWxShare = function ({ title, imgUrl, desc }, that) {
  if (window.peopleWXConfig && window.peopleWXConfig.appId) {
    wxShare({ title, imgUrl, desc })
  } else {
    loadWxScript(() => wxShare({ title, imgUrl, desc }))
  }
}
let n = 0
const wxShare = ({ title, imgUrl, desc }) => {
  const newImgUrl = imgUrl
  try {
    // eslint-disable-next-line no-undef
    peopleWXConfig.debug = false
    // eslint-disable-next-line no-undef
    peopleWXConfig.jsApiList = [
      'checkJsApi',
      // 'onMenuShareTimeline',
      // 'onMenuShareAppMessage',
      // 'onMenuShareQQ',
      // 'onMenuShareWeibo',
      'updateAppMessageShareData',
      'updateTimelineShareData',
      'chooseWXPay'
    ]
    // eslint-disable-next-line no-undef
    peopleWXConfig.openTagList = ['wx-open-launch-app']
    // eslint-disable-next-line no-undef
    wx.config(peopleWXConfig)
    // wx.config(peopleWXConfig);
    // eslint-disable-next-line no-undef
    wx.ready(function () {
      console.log(desc, '微信准备好了,wx.readywx.ready')
      const normalImg = 'https://cdn2-app.people.cn/static/shareLogo.png' + '?t=' + new Date().getTime()
      const shareData = {
        link: window.location.href,
        title,
        desc: desc || '',
        imgUrl: newImgUrl ? newImgUrl + '?t=' + new Date().getTime() : normalImg
      }
      // eslint-disable-next-line no-undef
      wx.updateAppMessageShareData(shareData)
      // eslint-disable-next-line no-undef
      wx.updateTimelineShareData(shareData)
    })
    // eslint-disable-next-line no-undef
    wx.error(function (res) {
      n++
      console.log(res, 'wx.error')
      if (n < 20) {
        setTimeout(() => {
          initWxShare({ title, imgUrl, desc })
        }, 200)
      }
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    })
  } catch (err) {
    console.log(err)
  }
}
const loadWxScript = (cb) => {
  // eslint-disable-next-line quotes
  const src = "//wx-api.people.com.cn/weixin/JS.js?url=" + encodeURIComponent(window.location) + '&timer=' + new Date().getTime()
  var ua = navigator.userAgent.toLowerCase() // 获取判断用的对象
  if (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
    importJs(src) // 在微信中打开
  }
  function importJs (src) {
    var script = document.createElement('script')
    script.src = src
    script.onload = script.onreadystatechange = function () {
      if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
        script.onload = script.onreadystatechange = null
        setTimeout(function () {
          if (cb && typeof cb === 'function')cb()
        }, 200)
      }
    }
    document.head.appendChild(script)
  }
}

export default initWxShare
